var _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFirst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "96px",
    height: "210px",
    viewBox: "0 0 96 210",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M95.4,210 L52.8,210 L52.8,73.8 L0,73.8 L0,41.7 C7.400037,41.900001 14.5499655,41.3500065 21.45,40.05 C28.3500345,38.7499935 34.5499725,36.4500165 40.05,33.15 C45.5500275,29.8499835 50.199981,25.500027 54,20.1 C57.800019,14.699973 60.299994,8.00004 61.5,0 L95.4,0 L95.4,210 Z",
    id: "path-1645029601688"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-1645029601688",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1645029601688"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-191,-131 L73.0029159,341.352281",
    id: "Line-2-Copy",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029601688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-181,-131 L83.0029159,341.352281",
    id: "Line-2-Copy-2",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029601688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-171,-131 L93.0029159,341.352281",
    id: "Line-2-Copy-3",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029601688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-161,-131 L103.002916,341.352281",
    id: "Line-2-Copy-4",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029601688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-151,-131 L113.002916,341.352281",
    id: "Line-2-Copy-5",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029601688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-141,-131 L123.002916,341.352281",
    id: "Line-2-Copy-6",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029601688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-131,-131 L133.002916,341.352281",
    id: "Line-2-Copy-7",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029601688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-121,-131 L143.002916,341.352281",
    id: "Line-2-Copy-8",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029601688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-111,-131 L153.002916,341.352281",
    id: "Line-2-Copy-9",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029601688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-101,-131 L163.002916,341.352281",
    id: "Line-2-Copy-10",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029601688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-91,-131 L173.002916,341.352281",
    id: "Line-2-Copy-11",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029601688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-81,-131 L183.002916,341.352281",
    id: "Line-2-Copy-12",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029601688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-71,-131 L193.002916,341.352281",
    id: "Line-2-Copy-13",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029601688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-61,-131 L203.002916,341.352281",
    id: "Line-2-Copy-14",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029601688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-51,-131 L213.002916,341.352281",
    id: "Line-2-Copy-15",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029601688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-41,-131 L223.002916,341.352281",
    id: "Line-2-Copy-16",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029601688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-31,-131 L233.002916,341.352281",
    id: "Line-2-Copy-17",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029601688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21,-131 L243.002916,341.352281",
    id: "Line-2-Copy-18",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029601688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11,-131 L253.002916,341.352281",
    id: "Line-2-Copy-19",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029601688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1,-131 L263.002916,341.352281",
    id: "Line-2-Copy-20",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029601688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,-131 L273.002916,341.352281",
    id: "Line-2-Copy-21",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029601688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,-131 L283.002916,341.352281",
    id: "Line-2-Copy-22",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029601688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,-131 L293.002916,341.352281",
    id: "Line-2-Copy-23",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029601688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,-131 L303.002916,341.352281",
    id: "Line-2-Copy-24",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029601688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,-131 L313.002916,341.352281",
    id: "Line-2-Copy-25",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029601688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,-131 L323.002916,341.352281",
    id: "Line-2-Copy-26",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029601688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69,-131 L333.002916,341.352281",
    id: "Line-2-Copy-27",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029601688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,-131 L343.002916,341.352281",
    id: "Line-2-Copy-28",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029601688)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,-131 L353.002916,341.352281",
    id: "Line-2-Copy-29",
    stroke: "#0061ED",
    strokeLinecap: "square",
    mask: "url(#mask-1645029601688)"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirst);
export default ForwardRef;